import React from "react";
import { Box } from "@mui/material";
import Section from "../../common/components/Section";
import SubSection from "../../common/components/SubSection";
import Title from "../../common/components/Title";
import Number from "../../common/components/Number";
import Topic from "../../common/components/Topic";
import Text from "../../common/components/Text";
import Content from "../../common/components/Content";
import Picture from "../../common/components/Picture";
import WithLove from "../../common/components/WithLove";
import Italics from "../../common/components/Italics";
import Bullet from "../../common/components/Bullet";
import joy from "../../images/allegory of joy.png";
import ark from "../../images/Ark opened.png";
import transition from "../../images/Transition.jpg";
import babe from "../../images/New born babe.png";
import well from "../../images/_Well of water_ by kevin carden.jpg";
import hoh from "../../images/Holy of holies.png";
import vine from "../../images/Vine tree.png";
import censer from "../../images/censer.png";
import jesus from "../../images/Salvation, Jesus.png";
import partyPopper from "../../images/party-popper.png";

export default function DayTwo() {
  return (
    <>
      <Box>
        <Topic>The Kingdom of God - Joy</Topic>
        <Text>John 3:3, Ephesians 5:5, 4:24, Romans 8:6</Text>
      </Box>

      <Section>
        <Picture src={hoh} />
        <br />
        <br />
        <SubSection>
          <Title>Study Background</Title>
          <Content>
            Over the last two days, we have found the grace to establish
            scriptural truths as touching the kingdom of God, redefining, and
            rebutting misconceptions. We have also looked into the Kingdom of
            Christ, his covenants of Righteousness and Peace, his laws of Faith,
            Hope, and Charity, and various allegories of this Kingdom. Anchored
            upon our text, <b>Rom. 14:17</b>, our study today will be focused on
            the third and final part of the Kingdom of God - Joy!
          </Content>
          <br />
          <Content>
            From our previous studies, we see from the scriptures that the
            Kingdom is divided into the Kingdom of Christ, and of God{" "}
            <b>(Eph. 5:5);</b> and yesterday, we looked at the Kingdom of Christ
            which consists of Righteousness and Peace.
            <br />
            <br />
            Therefore, it means that Joy is the living expression of the Kingdom
            of God. Joy is associated with the very presence of God{" "}
            <b>(Psa. 16:11),</b> and it is also the very fabric of salvation,{" "}
            <b>(Isa. 12:3, Psa. 132:16).</b> It follows that if salvation is
            everlasting <b>(Isa. 45:17),</b> then joy is the everlasting
            kingdom; all these we would look into today.
          </Content>
          <br />
          <Content>
            A very pivotal thought to hold onto in the course of this study is
            the concept of journeying. We would do well to note that everything
            we have studied from day one until now is the calibration of the
            journey of the believer. Kingdom is not given at the new birth;
            rather we take progressive steps into the kingdom. Today, we would
            be going deeper into the last domain of the kingdom of God.
          </Content>
        </SubSection>
      </Section>
      <Section>
        <SubSection>
          <Title>FERVENT CHARITY (1 Pet. 1:22-23, 4:8).</Title>

          <Content>
            We have established that the Kingdom of Christ peaks at Peace or
            Charity, <b>(1 Tim.1:5, Col. 3:14, 1 Cor. 13:13)</b> and it is the
            believer who has attained this estate that can be granted entrance
            into the Kingdom of Joy or the Everlasting Kingdom,{" "}
            <b>(Psa. 145:13, Dan. 4:3, 2 Pet. 1:11).</b>
            <br />
            <br />
            However, it is essential to point out that the everlasting kingdom
            has its ordinances and manner of entrance. The believer who has
            attained the Kingdom of Christ is required to fulfill the demand of
            fervent charity, to be administered entrance into the everlasting
            kingdom, <b>(2 Pet. 1:11).</b>
          </Content>
          <br />
          <Content>
            The word fervent has its root word in the Greek word{" "}
            <b>“ek-ten-ace”</b>
            which means to <b>stretch out</b>, and Charity, a common word we
            frequently use in our daily conversation, has its root word in the
            Greek <b>“ag-ah-pay”</b> which means <b>brotherly love</b>.
            Therefore, we can say{" "}
            <b>
              “fervent Charity” is an outstretched measure of brotherly love
            </b>
            .
          </Content>
          <br />
          <Content>
            Fervent charity simply explained, is to <b>abound</b> more in
            charity <b>(2 Thess. 1:3)</b>. It is the commandment given to those
            who have already obtained &#8216;like precious faith&#8217; and all
            things that pertain to life and godliness and are receiving things
            that would make them partakers of the divine nature,{" "}
            <b>(2 Pet. 1:3-4)</b> but while in the process, are required to
            abound in charity <b>(2 Pet. 1:5-8)</b>.
            <br />
            <br />
            <Picture src={censer} />
            <br />
            <br />
            Fervent charity can be likened to the heat in the womb or an
            incubator that is required to provide the right environmental
            conditions for the development and birth of the believer by the
            incorruptible seed, <b>(1 Pet. 1:22-23).</b> It is in this season
            that, the flock of God, by many tribulations, enters into the
            kingdom of God <b>(Acts 14:22).</b>
          </Content>
        </SubSection>
      </Section>
      <Section>
        <SubSection>
          <Title>THE EVERLASTING KINGDOM</Title>
          <Content>
            <br />
            <Picture src={ark} />
            <br />
            <br />
            <Italics>
              &#8220;Wherefore we receiving{" "}
              <b>a kingdom that cannot be moved</b>, let us have grace, whereby
              we may serve God acceptably with reverence and Godly fear&#8221;
              &ndash; <b>Heb. 12:18</b>.
            </Italics>
            <br />
            The Everlasting Kingdom is the Kingdom of Joy. It has been
            established in our previous lessons, that kingdom is the expression
            of a life. The Everlasting Kingdom is the expression of everlasting
            life. The Everlasting Kingdom is the inheritance of the Kingdom of
            God, <b>(Eph. 5:5).</b>
            <br />
            <br />
            It is the inheritance that makes the soul of the believer
            incorruptible, undefiled, and unfading, by the incorruptible seed
            (engrafted word), <b>(1 Pet. 1:3, 1 Pet. 1:23-24, Jam. 1:21).</b>
            {/* </Content>
					<Content> */}
            <br />
            <br />
            The Everlasting Kingdom is a kingdom that cannot be moved or shaken.
            This means that the word on which this Kingdom is established is
            sure and steadfast, <b>(Heb. 12:18, 2 Pet. 1:19).</b>
            <br />
            <br />
            So far, we have learned that for progress to be made into the
            kingdom at any level there is a will to be done or carried out; the
            will for the everlasting kingdom is the will of the father or the
            perfect will of God <b>(John 6:40, Rom. 12:2).</b>
          </Content>
          <br />
          <Number number={1}>
            <b>Salvation (Isa. 45:17)</b>
            <br />
            <br />
            <Picture src={jesus} />
            <br />
            <br />
            The calling of the believer by the new birth is to Inherit
            salvation, <b>(2 Tim. 1:10, Heb. 1:14).</b> According to the
            scriptures, salvation is the end of our faith, and everlasting life
            is also called the end; we can thus conclude that inheriting
            salvation is inheriting everlasting life,{" "}
            <b>(1 Pet. 1:9, Rom. 6:22).</b>
            <br />
            <br />A believer who is receiving salvation is said to be receiving
            the Kingdom that cannot be moved, which is the everlasting kingdom,{" "}
            <b>(1 Pet 1:9, Heb 12:28, Isa 45:17).</b> The coming of the
            everlasting kingdom is the reign of Salvation <b>(Rev. 12:10).</b>
          </Number>
          <br />
          <Number number={2}>
            <b>Partaking of the Divine Nature</b>
            <br />
            <br />
            <Picture src={vine} />
            <br />
            <br />
            <Italics>
              <b>2 Peter 1:4</b> &ndash; &#8220;Whereby are given unto us
              exceeding great and precious promises: that by these ye might be{" "}
              <b>partakers of the divine nature</b>, having escaped the
              corruption that is in the world through lust&#8221;.
            </Italics>
            <br />
            The believer who would partake of the divine nature must have
            attained life and godliness or have inherited the spiritual mind
            (nature), having escaped the corruption that is the world through
            lusts, which depicts the Kingdom of Christ{" "}
            <b>(2 Pet. 1:3, Rom. 8:6,10, Rom. 14:17).</b>
            <br />
            <br />
            Such a one would however, need to receive great and precious
            promises by the preaching of the everlasting gospel to become a
            partaker of the divine nature, which is the very promise of the life
            of God <b>(2 Cor. 7:1, 2 Pet. 1:4).</b>
          </Number>
          <br />
          <Number number={3}>
            <b>Being Born of the Incorruptible (1 Pet. 1:22-25)</b>
            <br />
            <br />
            <Picture src={babe} />
            <br />
            <br />
            The dealings of Christ make the heart of the believer pure in
            obedience to the truth through the Spirit, making it fit to receive
            the incorruptible seed for the believer to be born again. This birth
            process takes place under the conditions of fervent Charity.
            <br />
            <br />
            The incorruptible seed which is the seed/word of the everlasting
            kingdom is sown during the season of Fervent Charity and exposes the
            believer to the will or law of God thereby making the believer live
            and then abide.
          </Number>
          <br />
          <Number number={4}>
            <b>Joy (Isa. 45:17)</b>
            <br />
            <br />
            <Picture src={well} />
            <br />
            <br />
            <Italics>
              <b>Acts 20:24</b> &ndash; &#8220;But none of these things move me,
              neither count I my life dear unto myself, so that{" "}
              <b>I might finish my course with joy</b>...&#8221;
            </Italics>
            <br />
            The Kingdom of God, as we have established, is Righteousness and
            Peace and Joy in the Holy Ghost, <b>(Rom. 14:17).</b> We have before
            proven that Righteousness and Peace are expressions of life in the
            kingdom of Christ, <b>(Rom. 8:6).</b> We can therefore conclude that
            Joy is the expression of life in the kingdom of God, that is, the
            Everlasting Kingdom.
            <br />
            <br />
            The Apostle Paul in many of his afflictions chose not to count his
            life dear unto him that he would attain the Joy that is in the
            kingdom. <b>(Acts 20:24, 2 Tim. 4:18).</b>
          </Number>
        </SubSection>
      </Section>
      <Section>
        <SubSection>
          <Title>ALLEGORY OF JOY </Title>
          <Content>
            Joy is the destination of the believer. It is the end of the Journey
            of the soul. The journey from righteousness to peace is to end up in
            the Joy of the Lord. The Kingdom of Joy is the Presence of God and
            the place of pleasures forevermore{" "}
            <b>(Jude 1:24, 1 Pet. 1:8, Psa. 16:11)</b>.
            <br />
            <br />
            Joy is also the place of glory. The Glory of the Father is the
            inheritance of the believer. The desire of God from the foundation
            of the World is to bring many sons into glory and exceeding great
            Joy, <b>(Heb. 2:10, 1 Pet. 4:13)</b>. In the scriptures, there are
            some allegories of the kingdom of God, which we would be looking at
            below
          </Content>
        </SubSection>
        <SubSection>
          <Bullet>
            The Third Heaven which is the habitation of &#8220;his angels&#8221;
            who excel in strength and hearken to his commandment. They are also
            known as Cherubims. They are beings of Joy and Glory,{" "}
            <b>(Psa. 103:20, Heb. 9:5)</b>.
          </Bullet>
          <br />
          <Bullet>
            The true tabernacle or the holiest of all, according to the
            tabernacle which Moses pitched, <b>(Heb. 9:2)</b>.
          </Bullet>
          <br />
          <Bullet>
            According to Melchizedek priesthood, the expression of Joy is seen
            as &#8220;Priest of the Most High God&#8221;. This is where you are
            of no father and mother and of no natural descent, <b>(Heb. 7:3)</b>
            .
          </Bullet>
          <br />
          <br />
          <Picture src={joy} />
          <br />
          <br />
          <Bullet>
            The believer who has learned not to touch the unclean thing would be
            received by the father, to be begotten as sons and daughters who
            have inherited the promise of everlasting life{" "}
            <b>(2 Cor. 6:17-18)</b>.
          </Bullet>
        </SubSection>
        <SubSection>
          <Content>
            In Joy, you are fortified from &#8220;Iniquity&#8221; and taught to
            overcome Satan. In Joy, we are made full sons of God. This is where
            the inheritance of the Father (Everlasting life) and the reward of
            Eternal Life are given to a soul. It is important to note that the
            way we receive these lives in God is by teaching and preaching{" "}
            <b>(Acts 28:30-31, 1 Cor. 1:21)</b>.
          </Content>
        </SubSection>
      </Section>
      <Section>
        <SubSection>
          <Title>TRANSITION FROM PEACE TO JOY</Title>
          <Content>
            <br />
            <Picture src={transition} />
            <br />
            <br />
            <Italics>
              &#8220;Weeping may endure for a night, but joy comes in the
              morning &ndash;
              <b>Psalms 30:5</b>&#8221;
            </Italics>
            <br />A believer who has attained peace is one who has profited with
            the gospel of Christ and has escaped the corruption in the world
            through lust, <b>(1 Cor. 10:1-4, Rom. 8:6, 2 Pet. 1:3-4).</b> it is
            good to emphasize here that this believer fought his way through the
            ranks of evil spirits, that is, principalities, powers, and rulers
            of the darkness of this world. <b>(Eph. 6:12)</b>
            <br />
            <br />
            However, he still has higher ranks of wicked spirits (including
            Satan) to overcome, before he can be granted access into the
            everlasting kingdom, this implies that before and behind him are
            enemies. It is at this juncture the scriptures warn sternly against
            being satisfied with the state of peace and raises the need to press
            into salvation <b>(Amos 6:1, Heb. 6:1, Heb. 10:38).</b>
            <br />
            <br />
            There are examples of believers who fell short of their
            steadfastness in transitioning/pressing into salvation drew back to
            living in the filth of the world{" "}
            <b>(Heb. 6:4-6, 2 Pet. 2:20-23, 2 Tim. 4:10),</b> and even went as
            far as denying the Lord that bought them{" "}
            <b>(2 Pet 2:1, Jude 4:4).</b> Thus, it is dangerous to not advance
            into the kingdom of God, where the soul will be permanently
            inoculated against death.
          </Content>
        </SubSection>
      </Section>
      <Section>
        <SubSection>
          <Title>CONCLUSION</Title>
          <Content>
            We thank God for guiding us in wisdom to comprehend the Everlasting
            Kingdom. We have understood kingdom, the divisions of the kingdom
            &ndash; the kingdom of Christ and of God. We have also seen how we
            journey from one realm of the kingdom to another by learning and
            obedience.
            <br />
            <br />
            Finally, we have also understood that no believer should be at ease
            until the soul has been ushered into and abides in the kingdom of
            God. Indeed, the purpose of God for man is to end in the holy of
            holies, to be with him forever. We pray that, by the grace of God,
            our hearts will burn for the Everlasting Kingdom of God from now on
            until we are established therein in Jesus Name. Amen.
            <br />
            <br />
            Thank you for ascending with us! See you at Gadites Bible Seminar
            4.0.{" "}
            <img src={partyPopper} width={20} height={20} alt="party-popper" />
          </Content>
        </SubSection>
      </Section>
      <WithLove />
    </>
  );
}
